const invertedMessages = {
  // ── PreLaunchDashboard states ────────────────────────────────────────────
  'Analysis in Progress': 'certs.prelaunch.dashboard.running.title',
  'Re-analyzing…': 'certs.prelaunch.dashboard.reanalyzing',
  'This page will automatically refresh when the analysis completes.':
    'certs.prelaunch.dashboard.running.hint',
  'Analysis Failed': 'certs.prelaunch.dashboard.failed.title',
  'An unexpected error occurred.': 'certs.prelaunch.dashboard.failed.default',
  'Retrigger Analysis': 'certs.prelaunch.dashboard.retrigger',
  'Retriggering…': 'certs.prelaunch.dashboard.retriggering',
  'Loading report…': 'certs.prelaunch.dashboard.loading',

  // ── Aggregate count cards ────────────────────────────────────────────────
  'Aggregate Counts': 'certs.prelaunch.dashboard.aggregate',
  Users: 'certs.prelaunch.dashboard.users',
  Accounts: 'certs.prelaunch.dashboard.accounts',
  Entitlements: 'certs.prelaunch.dashboard.entitlements',
  Roles: 'certs.prelaunch.dashboard.roles',
  Certifiers: 'certs.prelaunch.dashboard.certifiers',
  Applications: 'certs.prelaunch.dashboard.applications',

  // ── Section headers ──────────────────────────────────────────────────────
  'Data Quality Insights': 'certs.prelaunch.dashboard.dq',
  'Risk Analysis': 'certs.prelaunch.dashboard.risk',
  'Certifier Data Quality Insights': 'certs.prelaunch.dashboard.certifier.dq',
  'Access Lifecycle Metrics': 'certs.prelaunch.dashboard.type.dq',
  'Access Risk Indicators': 'certs.prelaunch.dashboard.type.risk',

  // ── MetricTable column headers ───────────────────────────────────────────
  Metric: 'certs.prelaunch.metric.table.metric',
  Count: 'certs.prelaunch.metric.table.count',

  // ── Phase labels ─────────────────────────────────────────────────────────
  'Data Quality': 'certs.prelaunch.phase.data_quality',
  Finalizing: 'certs.prelaunch.phase.finalizing',

  // ── Data Quality metric labels (all campaign types) ──────────────────────
  'Missing Emails': 'certs.prelaunch.metric.missing_emails',
  'No Manager': 'certs.prelaunch.metric.no_manager',
  'Inactive Users': 'certs.prelaunch.metric.inactive_users',
  'Missing Department': 'certs.prelaunch.metric.missing_department',
  'Orphan Accounts': 'certs.prelaunch.metric.orphaned_accounts',
  'Disabled Endpoints': 'certs.prelaunch.metric.disabled_endpoints',
  'Inactive Manager': 'certs.prelaunch.metric.inactive_manager',
  'Users With Inactive Accounts':
    'certs.prelaunch.metric.users_with_inactive_accounts',
  'Default Certifier Usage': 'certs.prelaunch.metric.default_certifier',
  'Duplicate Records': 'certs.prelaunch.metric.duplicate_records',

  // ── Data Quality metric descriptions — User Manager (type 2) ─────────────
  'Users without a valid email address.':
    'PreLaunch.metric.missing_emails.description.type2',
  'Users in scope of campaign that are inactive.':
    'PreLaunch.metric.inactive_users.description.type2',
  'Users without a valid department name or number.':
    'PreLaunch.metric.missing_department.description.type2',
  'Accounts that are not associated with any users.':
    'PreLaunch.metric.orphaned_accounts.description.type2',
  'Endpoints in campaign scope that are disabled and will be excluded/ignored at launch.':
    'PreLaunch.metric.disabled_endpoints.description.type2',
  'Users with managers who are inactive.':
    'PreLaunch.metric.inactive_manager.description.type2',
  'Users with associated accounts that are inactive or manually suspended.':
    'PreLaunch.metric.users_with_inactive_accounts.description.type2',
  'Count of users/accounts/entitlements/roles assigned to the default certifier due to missing or invalid primary certifier.':
    'PreLaunch.metric.default_certifier.description.type2',
  'Users/Accounts/Entitlements/Roles which are duplicate/repeating.':
    'PreLaunch.metric.duplicate_records.description.type2',

  // ── Data Quality metric descriptions — Entitlement Owner (type 1) ────────
  'Entitlement owners without a valid email address, preventing certification notifications.':
    'PreLaunch.metric.missing_emails.description.type1',
  'Users associated with entitlements in scope who are currently inactive.':
    'PreLaunch.metric.inactive_users.description.type1',
  'Entitlement owners without a valid department name or number.':
    'PreLaunch.metric.missing_department.description.type1',
  'Accounts linked to entitlements that are not associated with any users.':
    'PreLaunch.metric.orphaned_accounts.description.type1',
  'Endpoints in scope of the entitlement owner campaign that are in inactive/disabled state.':
    'PreLaunch.metric.disabled_endpoints.description.type1',
  'Entitlement owners whose managers are currently inactive in the system.':
    'PreLaunch.metric.inactive_manager.description.type1',
  'Users with associated accounts that are inactive or manually suspended (type 1).':
    'PreLaunch.metric.users_with_inactive_accounts.description.type1',
  'Count of entitlements assigned to the default certifier due to missing or invalid entitlement owner.':
    'PreLaunch.metric.default_certifier.description.type1',
  'Entitlements, accounts, or users that appear as duplicate/repeating records in the campaign scope.':
    'PreLaunch.metric.duplicate_records.description.type1',

  // ── Data Quality metric descriptions — Service Account (type 6) ──────────
  'Service account owners without a valid email address, preventing certification notifications.':
    'PreLaunch.metric.missing_emails.description.type6',
  'Service account owners without a manager assigned in the system.':
    'PreLaunch.metric.no_manager.description.type6',
  'Users associated with service accounts in scope who are currently inactive.':
    'PreLaunch.metric.inactive_users.description.type6',
  'Service account owners without a valid department name or number.':
    'PreLaunch.metric.missing_department.description.type6',
  'Service accounts that are not associated with any owner or user.':
    'PreLaunch.metric.orphaned_accounts.description.type6',
  'Endpoints in scope of the service account campaign that are in inactive/disabled state.':
    'PreLaunch.metric.disabled_endpoints.description.type6',
  'Service account owners whose managers are currently inactive in the system.':
    'PreLaunch.metric.inactive_manager.description.type6',
  'Users with associated accounts that are inactive or manually suspended (type 6).':
    'PreLaunch.metric.users_with_inactive_accounts.description.type6',
  'Count of service accounts assigned to the default certifier due to missing or invalid account owner.':
    'PreLaunch.metric.default_certifier.description.type6',
  'Service accounts or associated records that appear as duplicate/repeating in the campaign scope.':
    'PreLaunch.metric.duplicate_records.description.type6',

  // ── Risk Analysis metric labels (all campaign types) ─────────────────────
  'Dormant Accounts': 'certs.prelaunch.metric.dormant_accounts',
  'Privileged Accounts': 'certs.prelaunch.metric.privileged_accounts',
  'SOD Violations': 'certs.prelaunch.metric.sod_violations',
  'Locked Accounts': 'certs.prelaunch.metric.locked_accounts',
  'Entitlements Without Metadata':
    'certs.prelaunch.metric.entitlements_without_metadata',

  // ── Risk Analysis metric descriptions (all campaign types) ───────────────
  'Accounts that have not been used for the last X days.':
    'PreLaunch.metric.dormant_accounts.description',
  'Accounts that are marked as privileged.':
    'PreLaunch.metric.privileged_accounts.description',
  'Count of Segregation of Duties violations across all the users.':
    'PreLaunch.metric.sod_violations.description',
  'Accounts that are currently in a locked state, potentially indicating security incidents or policy enforcement.':
    'PreLaunch.metric.locked_accounts.description',
  'Entitlements that are missing key metadata attributes such as description, display name, or glossary information.':
    'PreLaunch.metric.entitlements_without_metadata.description',
  'Entitlements flagged with a high risk level (critical entitlements).':
    'PreLaunch.metric.critical_entitlements.description',
  'Roles flagged with a high risk level based on configured risk scoring criteria.':
    'PreLaunch.metric.high_risk_roles.description',
  'Access items associated with a low user trust score.':
    'PreLaunch.metric.low_trust_access_items.description',

  // ── Risk Analysis metric descriptions — Entitlement Owner (type 1) ───────
  'Accounts holding entitlements in scope that have not been used for the last X days.':
    'PreLaunch.metric.dormant_accounts.description.type1',
  'Accounts holding entitlements in scope that are marked as privileged.':
    'PreLaunch.metric.privileged_accounts.description.type1',
  'Count of Segregation of Duties violations across entitlements and their associated users.':
    'PreLaunch.metric.sod_violations.description.type1',
  'Accounts holding entitlements in scope that are currently in a locked state.':
    'PreLaunch.metric.locked_accounts.description.type1',
  'Entitlements in scope that are missing key metadata attributes such as description, owner, or glossary information.':
    'PreLaunch.metric.entitlements_without_metadata.description.type1',

  // ── Risk Analysis metric descriptions — Service Account (type 6) ─────────
  'Service accounts that have not been used for the last X days.':
    'PreLaunch.metric.dormant_accounts.description.type6',
  'Service accounts that are marked as privileged.':
    'PreLaunch.metric.privileged_accounts.description.type6',
  'Count of Segregation of Duties violations across service accounts and their entitlements.':
    'PreLaunch.metric.sod_violations.description.type6',
  'Service accounts that are currently in a locked state.':
    'PreLaunch.metric.locked_accounts.description.type6',
  'Entitlements on service accounts that are missing key metadata attributes such as description or owner.':
    'PreLaunch.metric.entitlements_without_metadata.description.type6',

  // ── Certifier Data Quality metric labels (all campaign types) ────────────
  'Certifiers With No Email': 'certs.prelaunch.metric.certifiers_no_email',
  'Inactive Certifiers': 'certs.prelaunch.metric.inactive_certifiers',
  'Default Certifier Inactive':
    'certs.prelaunch.metric.default_certifier_inactive',
  'Default Certifier No Email':
    'certs.prelaunch.metric.default_certifier_no_email',
  'Reassignee With No Email': 'certs.prelaunch.metric.reassignee_no_email',

  // ── Certifier Data Quality metric descriptions (all campaign types) ───────
  'Certifiers assigned to review items who do not have a valid email address, preventing notification delivery.':
    'PreLaunch.metric.certifiers_no_email.description',
  'Certifiers assigned to review items who are currently in an inactive state in the system.':
    'PreLaunch.metric.inactive_certifiers.description',
  'The configured default certifier is in an inactive state, which may block fallback certification assignments.':
    'PreLaunch.metric.default_certifier_inactive.description',
  'The configured default certifier does not have a valid email address, preventing notification delivery.':
    'PreLaunch.metric.default_certifier_no_email.description',
  'Users designated as reassignment targets who do not have a valid email address for notifications.':
    'PreLaunch.metric.reassignee_no_email.description',

  // ── Certifier Data Quality metric descriptions — Entitlement Owner (type 1)
  'Entitlement owner certifiers who do not have a valid email address, preventing notification delivery.':
    'PreLaunch.metric.certifiers_no_email.description.type1',
  'Entitlement owner certifiers who are currently in an inactive state in the system.':
    'PreLaunch.metric.inactive_certifiers.description.type1',
  'The configured default certifier for the entitlement owner campaign is in an inactive state.':
    'PreLaunch.metric.default_certifier_inactive.description.type1',
  'The configured default certifier for the entitlement owner campaign does not have a valid email address.':
    'PreLaunch.metric.default_certifier_no_email.description.type1',
  'Users designated as reassignment targets in the entitlement owner campaign who lack a valid email address.':
    'PreLaunch.metric.reassignee_no_email.description.type1',

  // ── Certifier Data Quality metric descriptions — Service Account (type 6) ─
  'Service account certifiers who do not have a valid email address, preventing notification delivery.':
    'PreLaunch.metric.certifiers_no_email.description.type6',
  'Service account certifiers who are currently in an inactive state in the system.':
    'PreLaunch.metric.inactive_certifiers.description.type6',
  'The configured default certifier for the service account campaign is in an inactive state.':
    'PreLaunch.metric.default_certifier_inactive.description.type6',
  'The configured default certifier for the service account campaign does not have a valid email address.':
    'PreLaunch.metric.default_certifier_no_email.description.type6',
  'Users designated as reassignment targets in the service account campaign who lack a valid email address.':
    'PreLaunch.metric.reassignee_no_email.description.type6',

  // ── Access Lifecycle Metrics — User Manager (type 2) ─────────────────────
  'Users With No Entitlements':
    'certs.prelaunch.metric.users_with_no_entitlements',
  'Access Certified > 30 Days Ago':
    'certs.prelaunch.metric.access_last_certified_30',
  'Access Certified > 60 Days Ago':
    'certs.prelaunch.metric.access_last_certified_60',
  'Access Certified > 90 Days Ago':
    'certs.prelaunch.metric.access_last_certified_90',
  'Access Never Certified': 'certs.prelaunch.metric.access_never_certified',

  // ── Access Lifecycle metric descriptions — User Manager (type 2) ─────────
  'Users included in the campaign scope who have no entitlements assigned to any of their accounts.':
    'PreLaunch.metric.users_with_no_entitlements.description',
  'Access items where the last certification decision was made more than 30 days ago.':
    'PreLaunch.metric.access_last_certified_30.description',
  'Access items where the last certification decision was made more than 60 days ago.':
    'PreLaunch.metric.access_last_certified_60.description',
  'Access items where the last certification decision was made more than 90 days ago.':
    'PreLaunch.metric.access_last_certified_90.description',
  'Access items that have never been reviewed or certified in any previous campaign.':
    'PreLaunch.metric.access_never_certified.description',
  'Count of certifiers with more than 5,000 assigned records.':
    'PreLaunch.metric.certifier_overloaded.description',

  // ── Access Lifecycle metric descriptions — Entitlement Owner (type 1) ────
  'Entitlement access items where the last certification decision was made more than 30 days ago.':
    'PreLaunch.metric.access_last_certified_30.description.type1',
  'Entitlement access items where the last certification decision was made more than 60 days ago.':
    'PreLaunch.metric.access_last_certified_60.description.type1',
  'Entitlement access items where the last certification decision was made more than 90 days ago.':
    'PreLaunch.metric.access_last_certified_90.description.type1',
  'Entitlement access items that have never been reviewed or certified in any previous campaign.':
    'PreLaunch.metric.access_never_certified.description.type1',

  // ── Access Lifecycle metric descriptions — Service Account (type 6) ──────
  'Service account access items where the last certification decision was made more than 30 days ago.':
    'PreLaunch.metric.access_last_certified_30.description.type6',
  'Service account access items where the last certification decision was made more than 60 days ago.':
    'PreLaunch.metric.access_last_certified_60.description.type6',
  'Service account access items where the last certification decision was made more than 90 days ago.':
    'PreLaunch.metric.access_last_certified_90.description.type6',
  'Service account access items that have never been reviewed or certified in any previous campaign.':
    'PreLaunch.metric.access_never_certified.description.type6',

  // ── Access Risk Indicators — User Manager (type 2) ───────────────────────
  'High Risk Entitlements': 'certs.prelaunch.metric.high_risk_entitlements',
  'High SOX-Critical Entitlements':
    'certs.prelaunch.metric.high_sox_critical_entitlements',
  'High SYS-Critical Entitlements':
    'certs.prelaunch.metric.high_sys_critical_entitlements',
  'High Privilege Entitlements':
    'certs.prelaunch.metric.high_privilege_entitlements',
  'High Risk Roles': 'certs.prelaunch.metric.high_risk_roles',
  'High SOX-Critical Roles': 'certs.prelaunch.metric.high_sox_critical_roles',
  'High SYS-Critical Roles': 'certs.prelaunch.metric.high_sys_critical_roles',
  'High Privilege Roles': 'certs.prelaunch.metric.high_privilege_roles',
  'Roles with No Active Entitlements':
    'certs.prelaunch.metric.roles_no_active_entitlements',
  'Roles With Inherent SOD': 'certs.prelaunch.metric.roles_with_inherent_sod',
  'Accounts With SOD': 'certs.prelaunch.metric.accounts_with_sod',
  'Entitlements Causing SOD': 'certs.prelaunch.metric.entitlements_causing_sod',

  // ── Access Risk Indicator descriptions — User Manager (type 2) ───────────
  'Entitlements flagged with a high risk level based on configured risk scoring criteria.':
    'PreLaunch.metric.high_risk_entitlements.description',
  'Entitlements marked as SOX-critical, falling under Sarbanes-Oxley compliance requirements.':
    'PreLaunch.metric.high_sox_critical_entitlements.description',
  'Entitlements marked as system-critical, providing elevated or sensitive system-level access.':
    'PreLaunch.metric.high_sys_critical_entitlements.description',
  'Entitlements flagged as highly privileged, granting administrative or elevated permissions.':
    'PreLaunch.metric.high_privilege_entitlements.description',
  'Roles marked as SOX-critical, indicating they fall under Sarbanes-Oxley compliance requirements.':
    'PreLaunch.metric.high_sox_critical_roles.description',
  'Roles marked as system-critical, indicating they provide elevated or sensitive system-level access.':
    'PreLaunch.metric.high_sys_critical_roles.description',
  'Roles flagged as highly privileged, granting administrative or elevated permissions.':
    'PreLaunch.metric.high_privilege_roles.description',
  'Roles that currently have no active entitlements mapped to them, potentially indicating stale or unused role definitions.':
    'PreLaunch.metric.roles_no_active_entitlements.description',
  'Roles that inherently contain conflicting entitlements resulting in Segregation of Duties violations.':
    'PreLaunch.metric.roles_with_inherent_sod.description',
  'Accounts that have Segregation of Duties violations due to their combined entitlement assignments.':
    'PreLaunch.metric.accounts_with_sod.description',
  'Specific entitlements that are contributing to Segregation of Duties violations when combined with other access.':
    'PreLaunch.metric.entitlements_causing_sod.description',

  // ── Access Lifecycle Metrics — Entitlement Owner (type 1) ────────────────
  'Parent Entitlements': 'certs.prelaunch.metric.parent_entitlements',
  'Child Entitlements': 'certs.prelaunch.metric.child_entitlements',
  'Entitlements With No Accounts':
    'certs.prelaunch.metric.entitlements_no_accounts',
  'Orphan Accounts With Entitlements':
    'certs.prelaunch.metric.orphan_accounts_with_entitlements',
  'Inactive Entitlements': 'certs.prelaunch.metric.inactive_entitlements',
  'Users On Risky Entitlements':
    'certs.prelaunch.metric.users_on_risky_entitlements',

  // ── Access Lifecycle metric descriptions — Entitlement Owner (type 1) ────
  'Count of top-level (parent) entitlements included in the campaign scope.':
    'PreLaunch.metric.parent_entitlements.description',
  'Count of child entitlements (nested under parent entitlements) included in the campaign scope.':
    'PreLaunch.metric.child_entitlements.description',
  'Entitlements in scope that are not currently assigned to any accounts.':
    'PreLaunch.metric.entitlements_no_accounts.description',
  'Orphaned accounts (no associated user) that still hold active entitlements.':
    'PreLaunch.metric.orphan_accounts_with_entitlements.description',
  'Count of users who hold entitlements flagged as high-risk based on configured risk scoring.':
    'PreLaunch.metric.users_on_risky_entitlements.description',

  // ── Access Risk Indicators — Entitlement Owner (type 1) ──────────────────
  'Entitlements With SOD': 'certs.prelaunch.metric.entitlements_with_sod',

  // ── Access Risk Indicator descriptions — Entitlement Owner (type 1) ──────
  'Entitlements that are involved in Segregation of Duties violations when combined with other access.':
    'PreLaunch.metric.entitlements_with_sod.description',

  // ── Access Lifecycle Metrics — Service Account (type 6) ──────────────────
  'Distinct Account Types': 'certs.prelaunch.metric.distinct_account_types',
  'Accounts With No Entitlements':
    'certs.prelaunch.metric.accounts_no_entitlements',
  'Accounts with All Inactive Entitlements':
    'certs.prelaunch.metric.accounts_all_inactive_entitlements',
  'Application Roles In Scope':
    'certs.prelaunch.metric.application_roles_in_scope',

  // ── Access Lifecycle metric descriptions — Service Account (type 6) ──────
  'Count of unique account types (e.g., service, shared, system) present in the campaign scope.':
    'PreLaunch.metric.distinct_account_types.description',
  'Service accounts in scope that have no entitlements assigned to them.':
    'PreLaunch.metric.accounts_no_entitlements.description',
  'Service accounts where all associated entitlements are in an inactive or disabled state.':
    'PreLaunch.metric.accounts_all_inactive_entitlements.description',
  'Count of application roles associated with service accounts included in the campaign scope.':
    'PreLaunch.metric.application_roles_in_scope.description',
};

export default invertedMessages;
